// extracted by mini-css-extract-plugin
export default {"buttonActionCancelArea":"action-cancel-buttons-area_buttonActionCancelArea__4AEPU","cancel":"action-cancel-buttons-area_cancel__gpSIQ"};